import { Component, Input, OnInit } from '@angular/core';
import { Feature } from '../../generic/classes/feature';
import { FeatureGroup } from '../../generic/classes/featuregroup';
import { FilterService } from '../../generic/service/filter.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'feature-group',
    styleUrls: ['./filter.component.scss', './featuregroup.component.scss'],
    template: ` <h4>{{ featureGroup.description }}</h4>
        <ul class="filter-checkbox-list">
          @for (feature of featureGroup.features; track feature; let index = $index) {
            @if (showAll || index < limitAt) {
              <li
                class="filter-checkbox-list-item"
                >
                <label class="filter-checkbox-list_label">
                  <input
                    type="checkbox"
                    (click)="toggleFeature(feature)"
                    [checked]="isSelected(feature.id)" />
                  <span class="checkbox-icon">
                    <svg
                      class="icon-check"
                      width="14"
                      height="12"
                      viewBox="0 0 14 12">
                      <use
                      xlink:href="/images/icons/svg-sprite.svg#check"></use>
                    </svg>
                  </span>
                  @if (getFilterIcon(feature) != null) {
                    <span
                      class="filter-icon">
                      <img
                        width="20"
                        [src]="getFilterIcon(feature)"
                        alt="" />
                    </span>
                  }
                  <span class="filter-checkbox-list-item_name">
                    {{ feature.description }}
                  </span>
                  <span class="filter-checkbox-list-item_count">
                    ({{ feature.count }})
                  </span>
                </label>
              </li>
            }
          }
          @if (useShowAll) {
            <li
              class="filter-checkbox-list-item show-toggle">
              <a
                (click)="showAll = !showAll"
                    [ngClass]="{
                        'show--less': showAll,
                        'show--all': !showAll
                    }">
                @if (!showAll) {
                  <ng-container
                            i18n="
                                feature filters: show
                                more@@featuregroup.show.more">
                            Show more
                        </ng-container>
                }
                @if (showAll) {
                  <ng-container
                            i18n="
                                feature filters: show
                                less@@featuregroup.show.less">
                            Show less
                        </ng-container>
                }
                <span>
                  <svg
                    class="icon-arrow-down"
                    width="10"
                    height="7"
                    viewBox="0 0 12 7">
                    <use
                    xlink:href="/images/icons/svg-sprite.svg#arrow-down"></use>
                  </svg>
                </span>
              </a>
            </li>
          }
        </ul>`,
    standalone: true,
    imports: [NgClass],
})
export class FeatureGroupComponent implements OnInit {
    @Input() featureGroup: FeatureGroup;

    limitAt: number = 10;
    useShowAll: boolean;
    showAll: boolean = true;

    constructor(private filterService: FilterService) {}

    ngOnInit() {
        this.useShowAll = this.featureGroup.features.length > this.limitAt;

        if (this.useShowAll) {
            this.showAll = false;
        }
    }

    getFilterIcon(feature: Feature): string | null {
        const iconZonZwart = 1;
        const iconWolkZwart = 2;
        const iconZonWolkenZwart = 3;

        if (feature.plantscapingIcon === iconZonZwart) {
            return '/images/icons/zon-zwart.png';
        }
        if (feature.plantscapingIcon === iconWolkZwart) {
            return '/images/icons/wolk-zwart.png';
        }
        if (feature.plantscapingIcon === iconZonWolkenZwart) {
            return '/images/icons/zon-wolken-zwart.png';
        }
        return null;
    }

    isSelected(featureId): boolean {
        return this.filterService.isFeatureSelected(featureId);
    }

    toggleFeature(feature: Feature) {
        this.filterService.toggleFeature(feature.id);
    }
}
